import React, { createContext, useState, useEffect } from 'react';
import { useMediaContext } from './MediaProvider';
export const ParticipantsContext = createContext(null);
export const ParticipantsProvider = ({ children }) => {
    const { room } = useMediaContext();
    const [participants, setParticipants] = useState([]);
    // TODO :: we probably don't need this rly, saves some re-renders
    // useEffect(() => {
    //   if (dominantSpeaker) {
    //     setParticipants((prevParticipants) => [
    //       dominantSpeaker,
    //       ...prevParticipants.filter(
    //         (participant) => participant !== dominantSpeaker
    //       )
    //     ])
    //   }
    // }, [dominantSpeaker])
    useEffect(() => {
        if (!room)
            return;
        setParticipants(Array.from(room.participants.values()));
        const participantConnected = (participant) => {
            setParticipants((prevParticipants) => [...prevParticipants, participant]);
        };
        const participantDisconnected = (participant) => {
            setParticipants((prevParticipants) => prevParticipants.filter((p) => p !== participant));
        };
        room.on('participantConnected', participantConnected);
        room.on('participantDisconnected', participantDisconnected);
        return () => {
            room.off('participantConnected', participantConnected);
            room.off('participantDisconnected', participantDisconnected);
        };
    }, [room]);
    return (React.createElement(ParticipantsContext.Provider, { value: participants }, children));
};
//# sourceMappingURL=ParticipantsProvider.js.map